import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {Button, Typography} from 'antd';

import './landing.scss';

import EvenLayout from "../../layout/evenLayout/evenLayout";

import {replaceUrlByParams} from "../../utils/api";
import {PAGE} from "../../utils/constants";
import {AppContext} from "../../App";

function LandingPage() {
    const {Title, Paragraph} = Typography;
    const {appSetting} = useContext(AppContext)

    const meetMaxApp = appSetting.applicationCount >= appSetting.maxApplicationCount

    return (
        <EvenLayout
            className='landing-page'
            image={appSetting.image}
        >
            <div className='title'>
                <Title level={2}>{appSetting.title}</Title>
                <Paragraph
                    strong={true}
                    className='text-area-description'
                >
                   {appSetting.description}
                </Paragraph>
            </div>

            {appSetting.activated ?
                (
                    <>
                        {(meetMaxApp || !appSetting.enrolmentEnabled) && <Title level={4} code>{appSetting.enrolmentDisabledMsg}</Title> }
                        <div className='button-container'>
                            <Button type="primary" disabled={meetMaxApp || !appSetting.enrolmentEnabled}>
                                <Link
                                    to={`${replaceUrlByParams(PAGE.APPLICATION, {':pid': appSetting.programId})}`}>{appSetting.enrolButton}</Link>
                            </Button>

                            <Button type="primary">
                                <Link
                                    to={`${replaceUrlByParams(PAGE.USER_LOGIN, {':pid': appSetting.programId})}`}>{appSetting.checkResultButton}</Link>
                            </Button>
                        </div>

                    </>

                ) :
                (
                    <Title level={4} code>{appSetting.deactivatedMsg}</Title>
                )
            }
        </EvenLayout>
    );
}

export default LandingPage;
